import { useCallback, ReactElement, createElement } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { dayChange } from "../../actions";
import { getTodayDate } from "../../utils/date";

const h = createElement;

const LogoStyled = styled.div`
    color: ${({ theme }) => theme.colorAccent};
    text-align: center;
    line-height: 46px;
    cursor: pointer;
`;

export const Logo = (): ReactElement => {
    const dispatch = useDispatch();
    const onClickLogo = useCallback(() => {
        dispatch(dayChange(getTodayDate()));
    }, [dispatch]);
    return h(
        LogoStyled,
        {
            onClick: onClickLogo,
        },
        `pd`,
    );
};
